module.exports = __webpack_public_path__ + "Metronic_fda1334c35d0f5fe2afb3afebbb6774a.6b6feb61813dddd403e6.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/metronic/fonts/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.svg
// module id = ../../../../../src/assets/metronic/src/vendors/metronic/fonts/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.svg
// module chunks = styles